  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
//import TextField                                           from '@material-ui/core/TextField';
//import Checkbox                                            from '@material-ui/core/Checkbox';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  //[FAB]
  import Fab                                                 from '@material-ui/core/Fab';
  import CallIcon                                            from '@material-ui/icons/Call';
//import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';

  import List                                                from '@material-ui/core/List';
  import ListItem                                            from '@material-ui/core/ListItem';
  import ListItemText                                        from '@material-ui/core/ListItemText';
  import ListItemIcon                                        from '@material-ui/core/ListItemIcon';
  import Divider                                             from '@material-ui/core/Divider';
//import ArrowForwardIosIcon                                 from '@material-ui/icons/ArrowForwardIos';
  import ArrowRightIcon                                      from '@material-ui/icons/ArrowRight';

  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
//import { wu_RegisterGOVService }                           from "../../_services";
  import { wu_GeolocationService }                           from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import MoreStyle                                   from "./MoreStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import WU_FORM_arrow_right_forward                         from "assets/img/wu/WU_FORM_arrow_right_forward.svg";
  //----------
  // variables
  //----------
  const filename = "More ";
  const Transition = React.forwardRef(function Transition(props, ref) {
   return <Slide direction="up" ref={ref} {...props} />;
  });

  //[Lockers]
  var More_continue_locked = true;

class More extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //popup checkAppVersion
      dialog_checkAppVersion_isOpen                          : false,
      dialog_checkAppVersion_msg                             : "",

      //[FAB]
      fab_isHidden                                         : true,
      dialog100_msg                                        : "",
      dialog100_isOpen                                     : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                             = this.isLockersActive.bind(this);
    this.startLockers                                                = this.startLockers.bind(this);
    this.stopLockers                                                 = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                        = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                       = this.dialog200_handleClose.bind(this);

    //popup checkAppVersion
    this.dialog_checkAppVersion_handleOpen                           = this.dialog_checkAppVersion_handleOpen.bind(this);
    this.dialog_checkAppVersion_btn_ok                               = this.dialog_checkAppVersion_btn_ok.bind(this);

    //[FAB]
    this.fab_geoLocateIP                                             = this.fab_geoLocateIP.bind(this);
    this.fab_Click2CallAction                                        = this.fab_Click2CallAction.bind(this);
    this.dialog100_handleOpen                                        = this.dialog100_handleOpen.bind(this);
    this.dialog100_handleClose                                       = this.dialog100_handleClose.bind(this);

    this.findCountryNameFromCountryId                                = this.findCountryNameFromCountryId.bind(this);

    this.handleListItemClick0                                        = this.handleListItemClick0.bind(this); //SettingsProfile1
    this.handleListItemClick1                                        = this.handleListItemClick1.bind(this); //SettingsChangePass
    this.handleListItemClick2                                        = this.handleListItemClick2.bind(this); //SettingsTerms
    this.handleListItemClick3                                        = this.handleListItemClick3.bind(this); //SettingsPrivacy

    this.isWebAppIOS12x                                              = this.isWebAppIOS12x.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){
        wu_Utilities.LogoutUserFromApp(filename);
        history.push(wu_Utilities.getNavigationURLs("LoginPage"));
        return;
      }
    }

    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    this.clear_cardpayment_transfer_cookies();
    this.clear_cardpayment_bill_cookies();
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    //if(api.print_logs){console.log('cookie='+Cookies.set('testCookie',"test123"));}
    try { localStorage.setItem("LoginPage_flow",          "false"); } catch(err){;}
    try { localStorage.setItem("TransferOnlineLogin_flow","false"); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}
    try { localStorage.setItem("CustomerWantedToLoginToBills", "false"); } catch(err){;}

    this.checkAppVersion();
  }
  //----------------------------------------------------------------------------------------------------
  checkAppVersion(){
    let methName = filename+"checkAppVersion ";
    if(api.print_logs){console.log(methName);}

    //---------------
    //checkAppVersion---CACHED
    //---------------
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    let retrieveWSData_checkAppVersion = wu_AppVersion.wu_should_checkAppVersion();
    if(retrieveWSData_checkAppVersion){
      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("networkerror"));} //start DialogSpinner only if network connection will take place
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="More"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-WebService-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        if(res.isMajorUpdate===true){
          this.dialog_checkAppVersion_handleOpen(res.returnText);
          return;
        }
        //[FAB]
        this.fab_geoLocateIP();
      })
      .catch(err => {
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-SourceCode-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        //[FAB]
        this.fab_geoLocateIP();
      });
    }
    else{
      try{
        this.dialog200_handleClose();//stop DialogSpinner = YES
        if(api.print_logs){console.log("DataFrom-Cache-retrieveWSData_checkAppVersion="+retrieveWSData_checkAppVersion);}
        //[FAB]
        this.fab_geoLocateIP();
      }catch(err){
        console.log('err='+err);
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //[FAB]
  fab_geoLocateIP(){
    let methName = "fab_geoLocateIP";
    //SOS TODO cache for a certain period
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.setState({ "fab_isHidden":false }); return; }
    //-------------------
    //wu_getPhonePrefixes---STATIC
    //-------------------
    let phonePrefixes = wu_StaticDataService.wu_getPhonePrefixes({});
    //--------------
    //wu_geolocation
    //--------------
    wu_GeolocationService
    .wu_geolocation({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="More"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("parserObject_geolocation",JSON.stringify(res.location));
      let ws_country = "";
      try {ws_country = res.location["country"]; }catch(err){;} if(ws_country === null || (typeof ws_country ==="undefined")){ws_country = "";}
      for(let i=0; i<phonePrefixes.phone_prefixes.length; ++i){
        if(phonePrefixes.phone_prefixes[i]["descr"].indexOf(ws_country)>=0){
          localStorage.setItem("IPCOUNTRY",           phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          localStorage.setItem("UserSelectedCountry", phonePrefixes.phone_prefixes[i]["ctry_wu_id"]);
          break;
        }
      }
      //console.log(methName+"IPCOUNTRY="+localStorage.getItem("IPCOUNTRY"));
      if(localStorage.getItem("IPCOUNTRY")!==""){this.setState({ "fab_isHidden":false });}
    })
    .catch(err => {
      console.log(methName+"err="+err);
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container} ref={(ref) => this.section1 = ref}>
        <GridContainer justify="center">
          {/* [FAB] */}
          {this.state.fab_isHidden === true ? ( "" ) : (
            <Fab color="primary" aria-label="add" onClick={this.fab_Click2CallAction} className={classes.fab}>
              <CallIcon />
            </Fab>
          )}
          <GridItem xs={12} sm={6} md={6}>

            <div style={{ marginTop: 25 }}>
              <div className={classes.labelHeader}>{this.NSInforString("More_title")}</div>
              {/* <div className={classes.logo}><img src={logo} alt="logo" /></div> */}
            </div>

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.logo}><img src={logo} alt="logo" /></div>
              </GridItem>
            </GridContainer>

            <div style={{marginTop:20}}>
              <GridItem xs={12} sm={12} md={12}><div className={classes.More_header_lbl}>{this.NSInforString("More_lbl_MoneyTransfer_Header")}</div></GridItem>
              <List component="nav" aria-label="main mailbox folders">
                <ListItem onClick={this.handleListItemClick0} button>
                  <ListItemText primary={this.NSInforString("More_lbl_MoneyTransfer_Track")}/>
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                <Divider />
                <ListItem onClick={this.handleListItemClick1} button>
                  {localStorage.getItem("isLoggedIn")==="true" ?
                  ( <ListItemText primary={this.NSInforString("More_lbl_MoneyTransfer_History")}/> )
                  :
                  ( <ListItemText primary={this.NSInforString("More_lbl_MoneyTransfer_History")} style={{color:"lightgray"}}/> )}
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                <Divider />
              </List>
            </div>

            <div style={{marginTop:40, marginBottom:40}}>
              <GridItem xs={12} sm={12} md={12}><div className={classes.More_header_lbl}>{this.NSInforString("More_lbl_BillPayments_Header")}</div></GridItem>
              <List component="nav" aria-label="main mailbox folders">
                <ListItem onClick={this.handleListItemClick3} button>
                  {localStorage.getItem("isLoggedIn")==="true" ?
                  ( <ListItemText primary={this.NSInforString("More_lbl_BillPayments_History")}/> )
                  :
                  ( <ListItemText primary={this.NSInforString("More_lbl_BillPayments_History")} style={{color:"lightgray"}}/> )}
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                <Divider />
              </List>
            </div>

            <div style={{marginTop:40, marginBottom:40}}>
              <GridItem xs={12} sm={12} md={12}><div className={classes.More_header_lbl}>{this.NSInforString("More_lbl_EvenMore_Header")}</div></GridItem>
              <List component="nav" aria-label="main mailbox folders">
                <ListItem onClick={this.handleListItemClick2} button>
                  <ListItemText primary={this.NSInforString("More_lbl_BillPayments_SavedCards")} />
                  <ListItemIcon><ArrowRightIcon /></ListItemIcon>
                </ListItem>
                <Divider />
              </List>
            </div>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP][FAB]--- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog100_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog100_handleClose}
            aria-labelledby="alert-dialog100-slide-title"
            aria-describedby="alert-dialog100-slide-description"
          >
            <DialogTitle id="alert-dialog100-slide-title">{api.popup_tile}</DialogTitle>
            {localStorage.getItem("lang")==="en" ? (
              <DialogContent>Need assistance?<br/>We are at your disposal!<br/>Call us at<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>or<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(toll free from a landline)<br/><br/>Call Center operating hours:<br/>Monday to Sunday 08:00 με 21:00</DialogContent>
            ) : (
              <DialogContent>Χρειάζεσαι βοήθεια;<br/>Είμαστε στη διάθεσή σου!<br/>Κάλεσε μας στο<br/><b><a href="tel://2109005000">210 900 5000</a></b><br/>ή στο<br/><b><a href="tel://8001002020">800 100 2020</a></b><br/>(χωρίς χρέωση από σταθερό)<br/><br/>Ωράριο τηλεφωνικής εξυπηρέτησης:<br/>Δευτέρα με Κυριακή 08:00 με 21:00</DialogContent>
            )}
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog100_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* --------------------------------------- */}
        {/* ----------[POPUP checkAppVersion]------ */}
        {/* --------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_checkAppVersion_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_checkAppVersion_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_checkAppVersion_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_checkAppVersion} color="default" onClick={this.dialog_checkAppVersion_btn_ok}>{this.NSInforString("dialog_checkAppVersion_btn_ok")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //https://material-ui.com/components/lists/
  // function generate(element) {
  //   return [0, 1, 2].map(value =>
  //     React.cloneElement(element, {
  //       key: value,
  //     }),
  //   );
  // }

  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------ListItem Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  handleListItemClick0(event){
    let methName = filename+"handleListItemClick0 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //++++++++++++++++
    //SettingsProfile1
    //++++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("TrackTransfer"));
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick1(event){
    let methName = filename+"handleListItemClick1 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      //+++++++++++
      //HistoryList
      //+++++++++++
      history.push(wu_Utilities.getNavigationURLs("HistoryList"));
    }
    else{
      wu_Utilities.LogoutUserFromApp(filename);
      history.push(wu_Utilities.getNavigationURLs("LoginPage"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick2(event){
    let methName = filename+"handleListItemClick2 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    //this.dialog_handleOpen(this.NSInforString("More_lbl_comingSoon"));
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      //++++++++
      //CardList
      //++++++++
      history.push(wu_Utilities.getNavigationURLs("CardList"));
    }
    else{
      wu_Utilities.LogoutUserFromApp(filename);
      history.push(wu_Utilities.getNavigationURLs("LoginPage"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleListItemClick3(event){
    let methName = filename+"handleListItemClick3 ";
    if(api.print_logs){console.log(methName);}

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }

    if(wu_Utilities.checkIfUserIsLoggedIn()){
      //+++++++++++++++
      //SettingsPrivacy
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("BillsHistory"));
    }
    else{
      wu_Utilities.LogoutUserFromApp(filename);
      history.push(wu_Utilities.getNavigationURLs("LoginPage"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  findCountryNameFromCountryId(countryId){
    for(let i=0; i<this.state.parserObject_getCountries.length; ++i){
      if(this.state.parserObject_getCountries[i].ctry_wu_id===countryId){
        if(localStorage.getItem("lang")==="en"){ return this.state.parserObject_getCountries[i]["descr_en"]; }
        else                                   { return this.state.parserObject_getCountries[i]["descr_el"]; }
      }
    }
    return "";
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups checkAppVersion----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_checkAppVersion_isOpen" : true,
        "dialog_checkAppVersion_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_checkAppVersion_btn_ok(){
    window.location.reload(true);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( More_continue_locked===true ){ return true;  }
    else                                        { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    More_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    More_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[FAB]---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  fab_Click2CallAction(){
    if(localStorage.getItem("IPCOUNTRY")!==""){ this.dialog100_handleOpen(""); }
    else                                      { window.open(api.helpdeskURL, "Live Support", "toolbar=0,status=0,width=548,height=325"); }
  }
  dialog100_handleOpen(dialog_msg){
    this.setState({ "dialog100_isOpen" : true });
    this.setState({ "dialog100_msg"    : dialog_msg });
  }
  dialog100_handleClose(){
    this.setState({ "dialog100_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[CAMPAIGN]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog101_handleOpen(dialog_msg){
    this.setState({ "dialog101_isOpen" : true });
    this.setState({ "dialog101_msg"    : dialog_msg });
  }
  dialog101_handleClose(){
    this.setState({ "dialog101_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[COOKIES]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_transfer_cookies(){
    let methName = filename+"clear_cardpayment_transfer_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
    //try{ Cookies.remove('platform',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

    //try{ Cookies.remove('platform',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('lang',                                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    //try{ Cookies.remove('isLoggedIn',                            { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('centralID',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_PaymentMethod',         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_TransferMethod',        { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('TransferOnline1_selCountry_ctry_wu_id', { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('gross',                                 { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('normalCharges',                         { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('expectedActualPayout',                  { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_curr',                              { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('principal',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_fname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('rcv_lname',                             { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  clear_cardpayment_bill_cookies(){
    let methName = filename+"clear_cardpayment_bill_cookies ";
    if(api.print_logs){console.log(methName);}
    try{
      try{ Cookies.remove('accessToken',                           { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}

      try{ Cookies.remove('accessToken',                           { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('refreshToken',                          { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('tokenID',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('transId',                               { path:"/"}); }catch(err){console.log(methName+"err="+err);}
      try{ Cookies.remove('billId',                                { path:"/"}); }catch(err){console.log(methName+"err="+err);}
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------IOS12---------------------------------------------
  //----------------------------------------------------------------------------------------------------
  isWebAppIOS12x() {
    let methName = filename+"isWebAppIOS12x ";
    try{
      let ua = window.navigator.userAgent;
      if (/iP(hone|od|ad)/.test(ua)) {
        var v = (ua).match(/OS (\d+)_(\d+)_?(\d+)?/);
        //return parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10);
        console.log(methName+"iOS version="+parseInt(v[1], 10)+"."+parseInt(v[2], 10)+"."+parseInt(v[3] || 0, 10));
        if(parseInt(v[1], 10)===12){
          return true;
        }
      }
    }catch(err){
      console.log(methName+"err="+err);
    }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
}
More.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(MoreStyle)(More)
);
